<template>
  <div class="app-container">
    <!-- 主体区域 -->
    <main class="app-main">
      <div class="cate-container">
        <!-- 工具栏 -->
        <div class="toolbar">
          <div class="left-actions">
            <el-button type="primary" size="default" icon="el-icon-plus" @click="openAddDialog">
              新建分类
            </el-button>
            <span class="total-count">共 <strong>{{ totalCount }}</strong> 个分类</span>
          </div>
          <div class="right-actions">
            <el-button size="default" icon="el-icon-refresh" @click="loadCategories">刷新</el-button>
          </div>
        </div>

        <!-- 表格 -->
        <div class="table-wrap">
          <el-table
            v-loading="loading"
            :data="pagedData"
            stripe
            border
            style="width:100%"
            height="70vh"
            :row-style="{ height: '56px' }"
            :cell-style="{ padding: '8px 12px' }"
          >
            <el-table-column prop="id" label="ID" width="80" align="center" />
            <el-table-column prop="name" label="分类名称" min-width="200">
              <template slot-scope="{ row }">
                <span class="name-cell" :style="{ paddingLeft: getLevelPadding(row.level) }">
                  <span v-if="row.level > 1" class="level-prefix">└─ </span>
                  {{ row.name }}
                </span>
              </template>
            </el-table-column>
            <el-table-column prop="sort" label="排序" width="100" align="center">
              <template slot-scope="{ row }">
                <el-tag size="small" type="warning" effect="plain">{{ row.sort }}</el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="level" label="等级" width="120" align="center">
              <template slot-scope="{ row }">
                <el-tag :type="getLevelType(row.level)" size="small" effect="dark">
                  {{ getLevelLabel(row.level) }}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="parent_id" label="父级ID" width="100" align="center">
              <template slot-scope="{ row }">
                <span v-if="row.parent_id == 0" class="parent-tag">顶级</span>
                <el-tag v-else size="small" type="info" effect="plain">
                  {{ row.parent_id }}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="create_time" label="创建时间" min-width="170" align="center">
              <template slot-scope="{ row }">
                <span class="time-cell">{{ row.create_time || '—' }}</span>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="200" align="center" fixed="right">
              <template slot-scope="{ row }">
                <div class="action-group">
                  <el-button type="text" size="default" class="action-btn edit-btn" @click="openEditDialog(row)">
                    <i class="el-icon-edit"></i> 编辑
                  </el-button>
                  <span class="action-divider">|</span>
                  <el-button type="text" size="default" class="action-btn delete-btn" @click="handleDelete(row)">
                    <i class="el-icon-delete"></i> 删除
                  </el-button>
                </div>
              </template>
            </el-table-column>
            <template slot="empty">
              <div class="empty-state-custom">
                <div class="empty-icon-wrap">
                  <i class="el-icon-s-grid"></i>
                </div>
                <div class="empty-title">暂无分类</div>
                <div class="empty-sub">点击「新建分类」添加您的第一个分类</div>
                <el-button type="primary" size="small" plain @click="openAddDialog" style="margin-top:16px;">
                  + 立即创建
                </el-button>
              </div>
            </template>
          </el-table>
        </div>

        <!-- 分页 -->
        <div class="pagination-wrap">
          <el-pagination
            background
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalCount"
            :page-size="pageSize"
            :page-sizes="[10, 20, 50, 100]"
            :current-page.sync="currentPage"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          />
        </div>
      </div>
    </main>

    <!-- 新建/编辑弹窗 -->
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="560px"
      top="8vh"
      :close-on-click-modal="false"
      :destroy-on-close="true"
      class="dialog-form"
    >
      <el-form :model="form" label-width="80px" ref="formRef" size="default">
        <el-form-item
          label="分类名称"
          prop="name"
          :rules="[
            { required: true, message: '请输入分类名称', trigger: 'blur' },
            { max: 20, message: '最多20个字符', trigger: 'blur' }
          ]"
        >
          <el-input
            v-model="form.name"
            placeholder="请输入分类名称（最多20字）"
            maxlength="20"
            clearable
            size="default"
          />
          <span class="char-count">{{ form.name.length }}/20</span>
        </el-form-item>

        <el-form-item
          label="排序"
          prop="sort"
          :rules="[
            { required: true, message: '请输入排序值', trigger: 'blur' },
            { type: 'number', message: '排序必须为数字', trigger: 'blur' }
          ]"
        >
          <el-input-number
            v-model="form.sort"
            :min="0"
            :max="9999"
            controls-position="right"
            size="default"
            style="width:100%"
          />
          <span class="field-tip">数值越小，排序越靠前</span>
        </el-form-item>
        <!-- :rules="[
            { required: true, message: '请选择分类等级', trigger: 'change' },
            { type: 'number', min: 1, max: 3, message: '等级范围为3', trigger: 'blur' }
          ]" -->
        <el-form-item
          label="等级"
          prop="level"
        >
          <el-select v-model="form.level" placeholder="请选择分类等级" style="width:100%">
            <el-option
              v-for="n in 1"
              :key="n"
              :label="`${n}级分类`"
              :value="n"
            />
          </el-select>
          <!-- <span class="field-tip">1级为顶级分类，数值越大层级越深</span> -->
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button size="default" @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" size="default" :loading="saving" @click="submitForm">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import request from '@/utils/request'

// 接口基础地址
const BASE_URL = '/rcadmin/homeCate.php'

export default {
  name: 'CategoryManagement',
  data () {
    return {
      // ---------- 列表数据 ----------
      allData: [], // 所有分类数据
      loading: false,
      currentPage: 1,
      pageSize: 20,

      // ---------- 弹窗 ----------
      dialogVisible: false,
      dialogTitle: '',
      isEdit: false,
      saving: false,
      form: {
        id: null,
        name: '',
        sort: 0,
        level: 1
      }
    }
  },

  computed: {
    // 总记录数
    totalCount () {
      return this.allData.length
    },
    // 分页后的数据
    pagedData () {
      const start = (this.currentPage - 1) * this.pageSize
      const end = start + this.pageSize
      return this.allData.slice(start, end)
    }
  },

  created () {
    this.loadCategories()
  },

  methods: {
    // ---------- 查询分类 ----------
    async loadCategories () {
      this.loading = true
      try {
        const params = {
          page: 1,
          page_size: 1000 // 获取足够多的数据，前端分页
        }
        const res = await request.post(`${BASE_URL}?a=select`, params)
        if (res && res.code === '0') {
          // 按 sort 升序排列（sort 越小越靠前）
          const list = res.res || []
          this.allData = list.sort((a, b) => Number(a.sort) - Number(b.sort))
          // 重置到第一页
          this.currentPage = 1
        } else {
          this.$message.error(res?.msg || '加载分类失败')
          this.allData = []
        }
      } catch (err) {
        console.error('加载分类失败:', err)
        this.$message.error('网络错误，请检查连接')
        this.allData = []
      } finally {
        this.loading = false
      }
    },

    // ---------- 弹窗控制 ----------
    openAddDialog () {
      this.isEdit = false
      this.form = {
        id: null,
        name: '',
        sort: 0,
        level: 1
      }
      this.dialogTitle = '新建分类'
      this.dialogVisible = true
      this.$nextTick(() => {
        if (this.$refs.formRef) this.$refs.formRef.clearValidate()
      })
    },

    openEditDialog (row) {
      this.isEdit = true
      this.form = {
        id: row.id,
        name: row.name || '',
        sort: Number(row.sort) || 0,
        level: Number(row.level) || 1
      }
      this.dialogTitle = '编辑分类'
      this.dialogVisible = true
      this.$nextTick(() => {
        if (this.$refs.formRef) this.$refs.formRef.clearValidate()
      })
    },

    // ---------- 提交表单 ----------
    submitForm () {
      this.$refs.formRef.validate((valid) => {
        if (!valid) return
        if (!this.form.name || !this.form.name.trim()) {
          this.$message.warning('请输入分类名称')
          return
        }
        this.saving = true
        if (this.isEdit) {
          this.doEdit()
        } else {
          this.doAdd()
        }
      })
    },

    // ----- 新增 -----
    async doAdd () {
      const params = {
        name: this.form.name.trim(),
        sort: this.form.sort,
        level: this.form.level
      }
      try {
        const res = await request.post(`${BASE_URL}?a=add`, params)
        if (res && res.code === '0') {
          this.$message.success('分类创建成功')
          this.dialogVisible = false
          this.loadCategories()
        } else {
          this.$message.error(res?.msg || '创建失败')
        }
      } catch (err) {
        console.error('创建失败:', err)
        this.$message.error('网络错误，请重试')
      } finally {
        this.saving = false
      }
    },

    // ----- 编辑 -----
    async doEdit () {
      const params = {
        id: this.form.id,
        name: this.form.name.trim(),
        sort: this.form.sort,
        level: this.form.level
      }
      try {
        const res = await request.post(`${BASE_URL}?a=edit`, params)
        if (res && res.code === '0') {
          this.$message.success('分类更新成功')
          this.dialogVisible = false
          this.loadCategories()
        } else {
          this.$message.error(res?.msg || '更新失败')
        }
      } catch (err) {
        console.error('更新失败:', err)
        this.$message.error('网络错误，请重试')
      } finally {
        this.saving = false
      }
    },

    // ---------- 删除 ----------
    async handleDelete (row) {
      try {
        await this.$confirm(
          `确定要删除分类「${row.name}」吗？`,
          '提示',
          {
            confirmButtonText: '确定删除',
            cancelButtonText: '取消',
            type: 'warning'
          }
        )
        const params = { id: row.id }
        const res = await request.post(`${BASE_URL}?a=del`, params)
        if (res && res.code === '0') {
          this.$message.success('分类已删除')
          this.loadCategories()
        } else if (res && res.code === '1') {
          this.$alert(res.msg || '该分类下存在关联数据，无法删除', '提示', { confirmButtonText: '知道了' })
        } else {
          this.$message.error(res?.msg || '删除失败')
        }
      } catch (err) {
        if (err !== 'cancel') {
          console.error('删除失败:', err)
          this.$message.error('网络错误，请重试')
        }
      }
    },

    // ---------- 分页事件 ----------
    handleSizeChange (val) {
      this.pageSize = val
      this.currentPage = 1
    },
    handleCurrentChange (val) {
      this.currentPage = val
    },

    // ---------- 辅助方法 ----------
    // 根据等级获取缩进
    getLevelPadding (level) {
      const indent = Math.min(Number(level) - 1, 4) * 20
      return indent > 0 ? `${indent}px` : '0'
    },
    // 等级标签文字
    getLevelLabel (level) {
      const map = {
        1: '一级',
        2: '二级',
        3: '三级',
        4: '四级',
        5: '五级'
      }
      return map[level] || `${level}级`
    },
    // 等级标签颜色
    getLevelType (level) {
      const map = {
        1: 'success',
        2: 'primary',
        3: 'warning',
        4: 'danger',
        5: 'info'
      }
      return map[level] || 'info'
    }
  }
}
</script>

<style lang="scss" scoped>
/* ===== 全局布局 ===== */
.app-container {
  height: 100vh;
  display: flex;
  flex-direction: column;
  background: #f0f2f5;
  font-family: 'Helvetica Neue', 'PingFang SC', 'Microsoft YaHei', sans-serif;
}

/* ===== 主体区域 ===== */
.app-main {
  flex: 1;
  padding: 20px 24px 24px 24px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

/* ===== 分类容器 ===== */
.cate-container {
  flex: 1;
  display: flex;
  flex-direction: column;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
  overflow: hidden;
  padding: 20px 24px 24px 24px;
}

/* ===== 工具栏 ===== */
.toolbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 18px;
  flex-shrink: 0;
  flex-wrap: wrap;
  gap: 12px;

  .left-actions {
    display: flex;
    align-items: center;
    gap: 16px;

    .el-button--primary {
      font-weight: 500;
      box-shadow: 0 2px 8px rgba(24, 144, 255, 0.25);
      transition: all 0.25s;

      &:hover {
        box-shadow: 0 4px 16px rgba(24, 144, 255, 0.35);
        transform: translateY(-1px);
      }
    }
  }
  .right-actions {
    display: flex;
    align-items: center;
    gap: 10px;

    .el-button {
      color: #4e5969;
      &:hover {
        color: #1890ff;
      }
    }
  }
  .total-count {
    font-size: 14px;
    color: #86909c;
    padding: 4px 14px;
    background: #f5f6f8;
    border-radius: 20px;

    strong {
      color: #1d2129;
      font-weight: 600;
      font-size: 16px;
    }
  }
}

/* ===== 表格容器 ===== */
.table-wrap {
  flex: 1;
  overflow: hidden;
  position: relative;
  border-radius: 8px;
  border: 1px solid #eaedf2;

  .el-table {
    height: 100%;
    border-radius: 8px;

    .el-table__header-wrapper {
      .el-table__header {
        th {
          background-color: #f7f9fc !important;
          font-weight: 600;
          color: #1d2129;
          font-size: 14px;
          padding: 12px 12px;
          border-bottom: 2px solid #e8ecf1;
        }
      }
    }

    .el-table__body-wrapper {
      overflow-y: auto;

      .el-table__row {
        transition: background 0.2s;

        &:hover {
          background: #f5f9ff !important;
        }
      }
    }

    .el-table__empty-block {
      min-height: 280px;
    }
  }
}

/* ===== 单元格样式 ===== */
.name-cell {
  font-weight: 500;
  color: #1d2129;
  font-size: 14px;
  display: inline-block;
}

.level-prefix {
  color: #b0b8c4;
  font-weight: 300;
  margin-right: 2px;
}

.parent-tag {
  color: #b0b8c4;
  font-size: 13px;
}

.time-cell {
  color: #86909c;
  font-size: 13px;
}

/* ===== 操作按钮组 ===== */
.action-group {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0;

  .action-btn {
    padding: 0 8px;
    font-size: 13px;
    font-weight: 500;
    display: inline-flex;
    align-items: center;
    gap: 4px;

    i {
      font-size: 14px;
    }
  }

  .edit-btn {
    color: #1890ff;
    &:hover {
      color: #40a9ff;
    }
  }

  .delete-btn {
    color: #ff4d4f;
    &:hover {
      color: #ff7875;
    }
  }

  .action-divider {
    color: #d9d9d9;
    font-weight: 200;
    margin: 0 2px;
  }
}

/* ===== 空状态 ===== */
.empty-state-custom {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 48px 20px;

  .empty-icon-wrap {
    width: 80px;
    height: 80px;
    border-radius: 50%;
    background: #f5f7fa;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 16px;
    transition: all 0.3s;

    .el-icon-s-grid {
      font-size: 40px;
      color: #b7c0cc;
      transition: all 0.3s;
    }
  }

  &:hover .empty-icon-wrap {
    background: #e8f0fe;
    .el-icon-s-grid {
      color: #1890ff;
    }
  }

  .empty-title {
    font-size: 17px;
    font-weight: 600;
    color: #1d2129;
    margin-bottom: 4px;
  }

  .empty-sub {
    font-size: 14px;
    color: #b0b8c4;
  }
}

/* ===== 分页 ===== */
.pagination-wrap {
  flex-shrink: 0;
  padding-top: 16px;
  display: flex;
  justify-content: flex-end;
  border-top: 1px solid #f0f2f5;
  margin-top: 16px;

  .el-pagination {
    .el-pagination__total {
      font-weight: 400;
      color: #4e5969;
    }
    .el-pagination__sizes {
      .el-select .el-input__inner {
        border-radius: 6px;
      }
    }
    .el-pager li {
      border-radius: 6px;
      margin: 0 2px;
      &.active {
        background: #1890ff;
        color: #fff;
      }
    }
    .btn-prev,
    .btn-next {
      border-radius: 6px;
    }
  }
}

/* ===== 弹窗表单 ===== */
.dialog-form {
  .el-dialog {
    border-radius: 12px;
    overflow: hidden;

    .el-dialog__header {
      padding: 20px 24px 16px 24px;
      border-bottom: 1px solid #f0f2f5;
      background: #fafbfc;

      .el-dialog__title {
        font-size: 17px;
        font-weight: 600;
        color: #1d2129;
      }
    }

    .el-dialog__body {
      padding: 24px 28px 16px 28px;
    }

    .el-dialog__footer {
      padding: 12px 24px 20px 24px;
      border-top: 1px solid #f0f2f5;
      background: #fafbfc;
    }
  }

  .el-form-item {
    margin-bottom: 22px;

    .el-form-item__label {
      font-weight: 500;
      color: #1d2129;
    }
  }

  .char-count {
    position: absolute;
    height:24px;
    right: 10px;
    bottom: 15px;
    font-size: 12px;
    color: #c0c4cc;
    pointer-events: none;
    background: #fff;
    // padding: 0 4px;
  }

  .field-tip {
    display: block;
    font-size: 12px;
    color: #b0b8c4;
    margin-top: 4px;
    padding-left: 2px;
  }

  .el-input-number {
    .el-input-number__decrease,
    .el-input-number__increase {
      border-radius: 0;
    }
  }
}

/* ===== 响应式 ===== */
@media screen and (max-width: 768px) {
  .app-main {
    padding: 12px 12px 16px 12px;
  }
  .cate-container {
    padding: 14px 14px 16px 14px;
    border-radius: 8px;
  }
  .toolbar {
    flex-direction: column;
    align-items: stretch;
    .left-actions,
    .right-actions {
      justify-content: space-between;
      flex-wrap: wrap;
    }
  }
  .dialog-form .el-dialog {
    width: 94% !important;
    margin: 0 auto;
  }
  .pagination-wrap {
    .el-pagination {
      .el-pagination__sizes {
        display: none;
      }
      .el-pagination__jump {
        display: none;
      }
    }
  }
}
</style>
